export default "__VITE_ASSET__896395aa__"